import React from "react";
import styles from "./css/NossosProdutos.module.css";
import { FaUsers, FaMoneyBillWave, FaWhatsapp } from "react-icons/fa";
import logoGestorTx from "../../assets/images/logo - Gestor Tx 2.0.png";

export default function NossosProdutos() {
    return (
        <section id="produtos" className={styles.nossosProdutos} aria-labelledby="produtos-titulo">
            {/* Overlay com efeito glow */}
            <div className={styles.overlay} />

            <div className={styles.content}>
                {/* Logo em destaque */}
                <div className={styles.logoContainer}>
                    <img
                        src={logoGestorTx}
                        alt="Gestor Tx Logo"
                        className={styles.logo}
                    />
                </div>

                {/* Título e descrição */}
                <h2 id="produtos-titulo" className={styles.title}>
                    <span>Gestor Tx</span> — Gestão Inteligente
                </h2>
                <p className={styles.description}>
                    Plataforma online para gerenciar turmas, alunos e cobranças com eficiência e automação.
                    Ideal para academias, estúdios, escolinhas e cursos.
                </p>

                {/* Cards de funcionalidades */}
                <div className={styles.features}>
                    <div className={styles.card}>
                        <FaUsers className={styles.icon} aria-hidden="true" />
                        <h3>Gestão de Alunos</h3>
                        <p>Controle completo de turmas e alunos com facilidade.</p>
                    </div>

                    <div className={styles.card}>
                        <FaMoneyBillWave className={styles.icon} aria-hidden="true" />
                        <h3>Cobranças Automáticas</h3>
                        <p>Reduza inadimplência com cobranças seguras.</p>
                    </div>

                    <div className={styles.card}>
                        <FaWhatsapp className={styles.icon} aria-hidden="true" />
                        <h3>Integração com WhatsApp</h3>
                        <p>Envie notificações e lembretes direto pelo app.</p>
                    </div>
                </div>

                {/* Botão de chamada para ação */}
                <a
                    href="https://gestortx.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.ctaButton}
                >
                    Conheça o Gestor Tx
                </a>
            </div>
        </section>
    );
}
